<template>
    <span class="inline-select-operator" :class="{ open: dropdownVisible, placeholder: !selectedLabel }">
        <a-dropdown v-model="dropdownVisible" :trigger="['click']">
            <span class="select-trigger" @click="dropdownVisible = !dropdownVisible">
                {{ selectedLabel || placeholder }}
            </span>
            <a-menu slot="overlay" class="inline-select-operator-menu">
                <a-menu-item
                    v-for="option in options"
                    :key="option.value"
                    @click="selectOption(option)"
                >
                    {{ option.label }}
                </a-menu-item>
            </a-menu>
        </a-dropdown>
    </span>
</template>

<script>
export default {
    name: 'InlineSelectOperator',
    props: {
        value: {
            type: [String, Number, Boolean],
            default: '',
        },
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: 'select...',
        },
    },
    data() {
        return {
            dropdownVisible: false,
        };
    },
    computed: {
        selectedLabel() {
            const option = this.options.find(opt => opt.value === this.value);
            return option ? option.label : '';
        },
    },
    methods: {
        selectOption(option) {
            this.$emit('input', option.value);
            this.$emit('change', option.value);
            this.dropdownVisible = false;
        },
    },
};
</script>

<style scoped lang="scss">
.inline-select-operator {
    position: relative;
    display: inline-flex;
    align-items: center;

    .select-trigger {
        font-weight: 600;
        color: #9254de;
        border-bottom: 2px solid #9254de;
        padding: 2px 6px;
        cursor: pointer;
        transition: all 0.2s ease;
        display: inline-block;
        min-width: 70px;
        text-align: center;
        white-space: nowrap;
        border-radius: 2px;

        &:hover {
            background: #f9f0ff;
            border-bottom-color: #722ed1;
            transform: translateY(-1px);
        }
    }

    &.placeholder .select-trigger {
        color: #bfbfbf;
        border-bottom-color: #d9d9d9;
        font-style: italic;
        font-weight: 500;
    }

    &.open .select-trigger {
        background: #f9f0ff;
        box-shadow: 0 2px 4px rgba(146, 84, 222, 0.2);
    }
}
</style>

<style lang="scss">
.inline-select-operator-menu {
    max-height: 350px;
    overflow-y: auto;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
    border-radius: 6px;

    .ant-menu-item {
        display: flex;
        align-items: center;
        padding: 10px 16px;
        transition: all 0.2s ease;
        border-left: 3px solid transparent;

        &:hover {
            background: #f9f0ff;
            color: #9254de;
            border-left-color: #9254de;
        }
    }
}
</style>

